import { useWidgetSettings } from '../../hooks/useWidgetSettings';
import { SharedWidget, WidgetConfig } from './SharedWidget';

export function WidgetPreview() {
  const { settings } = useWidgetSettings();

  // Transform dashboard settings to widget config
  const widgetConfig: WidgetConfig = {
    mode: 'floating',
    position: settings.position,
    offset: settings.offset,
    customIcon: settings.customIcon || undefined,
    welcomeMessage: settings.welcomeMessage || 'Hello! How can I help you?',
    showWelcomeMessage: settings.showWelcomeMessage,
    showNotificationBubble: settings.showNotificationBubble,
    enableAnimation: settings.enableAnimation,
    lang: settings.lang
  };

  return (
    <div className="absolute inset-0 flex items-end justify-end p-4">
      <SharedWidget
        config={widgetConfig}
        preview={true}
      />
    </div>
  );
}